import { render, staticRenderFns } from "./NormalOrder.vue?vue&type=template&id=3f4671e2&scoped=true"
import script from "./NormalOrder.vue?vue&type=script&lang=js"
export * from "./NormalOrder.vue?vue&type=script&lang=js"
import style0 from "./NormalOrder.vue?vue&type=style&index=0&id=3f4671e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4671e2",
  null
  
)

export default component.exports